import type { ParsedUrlQuery } from 'querystring';

import { shopifyHandles } from '../shop';

export const _getPath = (query: ParsedUrlQuery, fromPath: string) => {
  if (query?.referrer === 'system') {
    return `/shop/${shopifyHandles.screen}`;
  }
  if (query?.setup === 'true') {
    return '/register/onboarding';
  }
  return fromPath;
};
